/**
 * Page parametres du compte utilisateur
 * Wrapper autour du composant AccountSettings du module auth
 */

import { useNavigate } from 'react-router-dom';
import { useAuth, AccountSettings } from '@features/auth';

export function AccountSettingsPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <div className="flex justify-center">
      <AccountSettings
        userId={user.id}
        showDeleteSection={true}
        onAccountDeleted={async () => {
          await logout();
          navigate('/auth/login');
        }}
      />
    </div>
  );
}
